import React from 'react';
export function CostComparison() {
  return <section className="py-20 bg-white" data-id="element-45">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-serif font-bold flex items-center justify-center gap-3" data-id="element-48">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-16 rounded-xl border border-beige-dark shadow-sm" data-id="element-49">
          <table className="w-full text-sm text-left min-w-[600px]" data-id="element-50">
            <thead className="bg-charcoal text-white font-bold" data-id="element-51">
              <tr data-id="element-52">
                <th className="px-6 py-4" data-id="element-53">Sin Pack CI 6×6</th>
                <th className="px-6 py-4 bg-gold text-charcoal" data-id="element-54">Costo Real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-beige-dark bg-white" data-id="element-55">
              {[['3 fines de semana buscando info que no aplica', 'Tiempo perdido sin resultado'], ['Presupuestos que no podés comparar', 'Pagás de más sin saberlo'], ['Materiales comprados sin cómputo previo', '15-20% de desperdicio = $150.000-$300.000'], ['Obra sin contrato ni checklist', 'Un conflicto puede costarte el doble de lo ahorrado'], ['Distribución sin layout verificado', 'Ventana mal ubicada = obra que hay que rehacer'], ['El mismo ciclo de dudas, el próximo fin de semana', 'Terreno sin construir otro año más']].map((row, i) => <tr key={i} className="hover:bg-beige/30 transition-colors" data-id="element-56">
                  <td className="px-6 py-4 font-medium text-gray-700" data-id="element-57">
                    {row[0]}
                  </td>
                  <td className="px-6 py-4 text-red-600 font-bold" data-id="element-58">{row[1]}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto space-y-6" data-id="element-59">
          <h3 className="text-2xl font-bold text-charcoal" data-id="element-60">
            El próximo fin de semana puede ser diferente.
          </h3>
          <div className="bg-beige p-8 rounded-xl border border-beige-dark relative" data-id="element-61">
            <span className="absolute top-4 left-4 text-4xl text-gold/30 font-serif" data-id="element-62">
              "
            </span>
            <p className="text-xl font-serif italic text-gray-800 relative z-10" data-id="element-63">
              El terreno más caro no es el más caro del mercado. Es el que
              compraste hace dos años y todavía no construiste.
            </p>
            <span className="absolute bottom-0 right-4 text-4xl text-gold/30 font-serif" data-id="element-64">
              "
            </span>
            <div className="mt-4 text-2xl" data-id="element-65">🏗️</div>
          </div>
        </div>
      </div>
    </section>;
}